// https://stackoverflow.com/a/50780874/3629111
if (!Object.values) Object.values = o => Object.keys(o).map(k => o[k])
